import ColorSelector from './colorSelector';
export default ColorSelector;
